import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export enum AgreementStatus {
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable'
}

export enum InvoiceFrequency {
  WEEKLY = 'weekly',
  MONTHLY = 'monthly'
}

export enum PricingGroupType {
  VENDOR = 'vendor',
  VENDOR_DESI = 'vendor_desi',
  VENDOR_SIZE = 'vendor_size',
  NONE = 'none'
}

export enum PricingServicesEnum {
  SMS = 'SMS',
  SECURITY_DEPOSIT_REFUNDABLE = 'SECURITY_DEPOSIT_REFUNDABLE', // Geri ödemeli
  SECURITY_DEPOSIT_NON_REFUNDABLE = 'SECURITY_DEPOSIT_NON_REFUNDABLE' // Geri ödemesiz
}

export class PricingAddon {
  name: string;
  price: number;
  multiplier: number;
  isReturned: boolean;
}

export class PricingMatrix {
  desi: number;
  price: number;
  multiplier: number;
}

export class RegionPricing {
  packageTypes: (number | string)[];
  matrix: PricingMatrix[];
  addons: PricingAddon[];
}

export class Region {
  name: string;
  pricing: RegionPricing[];
}

export class RegionMapping {
  regionName: string;
  countries?: number[];
  cities?: number[];
  subcities?: number[];
  vendorIds?: number[];
  companyIds?: number[];
  fromIds?: number[];
  isReturn: boolean;
}

/** Matrisin okunduğu ölçü: desi (varsayılan) ya da brüt kg (cityapi pricingUnit) */
export type PricingUnit = 'desi' | 'kg';

export class Agreements {
  id: string;
  isAccepted?: boolean;
  companyIds: number[];
  startDate: string;
  endDate: string;
  status: 'available' | 'unavailable';
  invoiceFrequency: InvoiceFrequency;
  invoiceDay: number;
  groupType: PricingGroupType;
  pricingUnit?: PricingUnit;
  regionMapping: RegionMapping[];
  regions: Region[];
  createdAt: string;
}

export class IAgreementsResponse {
  @Type(() => Agreements)
  result: Agreements;
}

export class IAgreementsListResponse extends IPagination {
  @Type(() => Agreements)
  results: Agreements[];
}

export class IAgreementsPostDto {
  companyIds: number[];
  startDate: string;
  endDate: string;
  status: 'available' | 'unavailable';
  invoiceFrequency: InvoiceFrequency;
  invoiceDay: number;
  groupType: string;
  pricingUnit?: PricingUnit;
  regionMapping: RegionMapping[];
  regions: Region[];
  isAccepted?: boolean;
}

export class IAgreementsQueryDto extends IQueryPaginationDto {
  id?: string;
  companyId?: (string | number)[];
  status?: AgreementStatus;
  isAccepted?: string;
  invoiceFrequency?: InvoiceFrequency;
  invoiceDay?: number;
  invoiceDayMin?: number;
  invoiceDayMax?: number;
  groupType?: PricingGroupType;
  groupTypes?: string;
  startDateFrom?: string;
  startDateTo?: string;
  endDateFrom?: string;
  endDateTo?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  isActive?: string;
  isExpired?: string;
  isUpcoming?: string;
  regionName?: string;
  vendorId?: number;
  vendorIds?: (string | number)[];
  ids?: string;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export class IPatchAgreementsBodyDto {
  companyIds?: number[];
  startDate?: string;
  endDate?: string;
  status?: 'available' | 'unavailable';
  invoiceFrequency?: InvoiceFrequency;
  invoiceDay?: number;
  groupType?: string;
  pricingUnit?: PricingUnit;
  regionMapping?: RegionMapping[];
  regions?: Region[];
  isAccepted?: boolean;
}

class AgreementCompaniesWithoutAgreementListResponseItem {
  id: number;
  phone: string;
  createdAt: string;
  point_id: number;
}

export class AgreementCompaniesWithoutAgreementListResponse extends IPagination {
  @Type(() => AgreementCompaniesWithoutAgreementListResponseItem)
  results: AgreementCompaniesWithoutAgreementListResponseItem[];
  meta: {
    total: number;
    totalPages: number;
  };
}

export class AgreementCompaniesWithoutAgreementQueryDto extends IQueryPaginationDto {}

export class IAgreementsStatisticsThisYear {
  total: number;
  accepted: number;
  notAccepted: number;
}

export class IAgreementsStatisticsCompanies {
  total: number;
  accepted: number;
  notAccepted: number;
}

export class IAgreementsStatisticsResponse {
  total: number;
  accepted: number;
  notAccepted: number;
  @Type(() => IAgreementsStatisticsThisYear)
  thisYear: IAgreementsStatisticsThisYear;
  @Type(() => IAgreementsStatisticsCompanies)
  companies: IAgreementsStatisticsCompanies;
  year: number;
}
